import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import Lottie from "lottie-react";

import loadingAnimation from "./reploading.json";

const loadingMessages = [
  "adding in your custom content...",
  "tidying up spacing and alignment...",
  "syncing in your product data...",
];

const FullPageLoadingAnimation = ({ className }: { className?: string }) => {
  const [textIndex, setTextIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((textIndex) => (textIndex + 1) % loadingMessages.length);
    }, 4750);

    return () => clearInterval(interval);
  }, []);
  return (
    <div
      className={twMerge(
        "flex flex-col items-center justify-center gap-7 pt-[72px]",
        className,
      )}
    >
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        className="z-10 w-[250px] flex-1"
      />
      <div className="text-muted text-center">{loadingMessages[textIndex]}</div>
    </div>
  );
};

export default FullPageLoadingAnimation;
